import {isNaN} from "./helpers/is-nan.js";

class Count {
  constructor(container) {
    this.container = container;
    this.buttonIncrease = container.querySelector('.js-count-increase');
    this.buttonDecrease = container.querySelector('.js-count-decrease');
    this.input = container.querySelector('.js-count-input');

    const inputValue = Number(this.input.value);
    this.value = isNaN(inputValue) ? 1 : inputValue;

    this.valueMin = 1;

    this.init();
  }

  init() {
    const step = 1;

    this.buttonIncrease.addEventListener('click', () => this.increase(step));
    this.buttonDecrease.addEventListener('click', () => this.decrease(step));

    this.input.addEventListener('input', (e) => this.value = Number(e.target.value));
    $(this.input).on("update",(event)=>{
      this.value = Number(event.target.value);
    });
  }

  increase(step) {
    this.value += step;
    this.render();
  }

  decrease(step) {
    const newValue = this.value - step;
    this.value = newValue >= this.valueMin ? newValue : this.valueMin;
    this.render();
  }

  render() {
    this.input.value = this.value;
  }
}

document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('.js-count').forEach((item) => {
    new Count(item);
  })
});
